import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Plus, UserPlus, Users } from 'lucide-react';

interface ContactsEmptyStateProps {
  onAddContact?: () => void;
}

export function ContactsEmptyState({ onAddContact }: ContactsEmptyStateProps) {
  return (
    <Card className="border-dashed border-2 border-muted-foreground/25 bg-muted/5">
      <CardContent className="flex flex-col items-center justify-center py-12 px-6 text-center">
        {/* Icon */}
        <div className="relative mb-6">
          <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center">
            <Users className="w-8 h-8 text-primary" />
          </div>
          <div className="absolute -top-2 -right-2 w-8 h-8 bg-secondary rounded-full flex items-center justify-center">
            <UserPlus className="w-4 h-4 text-secondary-foreground" />
          </div>
        </div>

        {/* Content */}
        <h3 className="text-lg font-semibold mb-2">No Contacts Yet</h3>
        <p className="text-muted-foreground mb-6 max-w-md">
          Start building your network by adding contacts for your properties,
          service providers, and business relationships.
        </p>

        {/* Action Button */}
        {onAddContact && (
          <Button onClick={onAddContact} className="flex items-center">
            <Plus className="w-4 h-4 mr-2" />
            Add Your First Contact
          </Button>
        )}

        {/* Additional Info */}
        <div className="mt-6 text-xs text-muted-foreground">
          <p>Store contact information for property managers, contractors,</p>
          <p>tenants, and other important business contacts.</p>
        </div>
      </CardContent>
    </Card>
  );
}
